import { createAction, props } from '@ngrx/store';
import { IRefusedData, IRefusedModel } from '@partners/api';

export class RefusedActions {
  static reset = createAction('[Refused] Reset State');
  static load = createAction('[Refused] Load');
  static loadSuccess = createAction('[Refused] Load Success', props<{ model: IRefusedModel; data: IRefusedData }>());
  static loadFailure = createAction('[Refused] Load Failure', props<{ error: any }>());
  static submit = createAction('[Refused] Submit');
  static submitSuccess = createAction(
    '[Refused] Submit Success',
    props<{ model: IRefusedModel; data: IRefusedData }>()
  );
  static submitFailure = createAction('[Refused] Submit Failure', props<{ error: any }>());
}
